<article>
  <div class="header">
    <opac-icon [class.completed]="challenge.progress >= challenge.target" icon="badge_challenge" size="2x"></opac-icon>

    <span class="completed-title" [class.completed]="challenge.progress >= challenge.target">
      {{ (challenge.progress >= challenge.target ? 'challenges.completed' : 'challenges.uncompleted') | translate }}
    </span>
  </div>

  <div class="contents">
    <span class="completed-title" [class.completed]="challenge.progress >= challenge.target">
      {{ (challenge.progress >= challenge.target ? 'challenges.completed' : 'challenges.uncompleted') | translate }}
    </span>

    <h3>{{ challenge.name }}</h3>

    <div *ngIf="expanded" @accordionTop class="content-container">
      <p>{{ getChallengeDescriptionLabel() | translate }}</p>
    </div>

    <div class="createdBy">
      <span>{{ 'challenges.createdByAdmin' | translate }} - {{ challenge.creationDate | date:'mediumDate' }}</span>
    </div>

    <opac-button class="expander" [class.expanded]="expanded" (click)="toggleDescription()">
      <opac-icon icon="expand_more" slot="only-icon"></opac-icon>
    </opac-button>
  </div>

  <div class="controls">
    <div class="createdBy">
      <span>{{ 'challenges.createdByAdmin' | translate }}<br>{{ challenge.creationDate | date:'mediumDate' }}</span>
    </div>
  </div>
</article>
